import {NextPage} from "next";
import Head from "next/head";
import {AffiliateAdminView} from "../../components/affiliateAdmin/AffiliateAdminView";
import {wrapper} from "../../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";

const Affiliates: NextPage = () => {
  return <>
    <Head>
      <title>Affiliate Admin</title>
    </Head>
    <AffiliateAdminView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate']),
    }
  }
});


export default Affiliates